export const JOIN_SOURCES = [
  "invite",
  "vanity",
  "discovery",
  "bot",
  "integration",
  "other",
  "unknown",
] as const;

export type JoinSource = (typeof JOIN_SOURCES)[number];
